module.exports = __webpack_public_path__ + "static/media/logo_auth.f7fe7a16.png";